export const TYPEFORM_URL = "https://bwwfj0sh354.typeform.com/to/Bt2W8QXi";

// Verbatim copy from clientsclick.com
export const PILLARS = [
    {
        id: "01",
        name: "Influencer Engine",
        tagline: "Less stress, more systems, and real results.",
        description:
            "You shouldn't have to worry about all the boring tasks that take up 80% of your time. Less stress, more systems, and real results. You focus on creating, we handle the rest.",
        cta: "View more",
    },
    {
        id: "02",
        name: "Audience Creation",
        tagline: "Stop winging it and start winning!",
        description:
            "You're posting everyday but growth still feels stuck? The algorithm and automation builds your audience - now let's turn them into loyal buyers. Stop winging it and start winning!",
        cta: "View more",
    },
    {
        id: "03",
        name: "Content Hub",
        tagline: "Consistency without chaos!",
        description:
            "No more content anxiety... Tap into the money hiding in your brand. Consistency without chaos! That's the power of Data and AI. Turn your hustle into a hands free process.",
        cta: "View more",
    },
    {
        id: "04",
        name: "Brand Elevation",
        tagline: "Leverage your existing audience!",
        bullets: [
            "Leverage your existing audience!",
            "Data driven insights show where fans drop off and what's underperforming.",
            "Get more engagement and retention with a deeper fan connection.",
        ],
        cta: "Learn More",
    },
    {
        id: "05",
        name: "Irresistible Offer",
        tagline: "Turn fan engagement into income with a no brainer sales funnel!",
        bullets: [
            "Turn fan engagement into income with a no brainer sales funnel!",
            "10X your profit by fully monetizing your audience.",
            "Turn viewers into buyers WITHOUT lifting a finger.",
            "Rapidly scale while you connect with your fans. It's a win-win!",
        ],
        cta: "Learn More",
    },
    {
        id: "06",
        name: "360 Automation",
        tagline: "Never miss a DM — we automate from first like to final sale.",
        bullets: [
            "End creator burnout — no more busy work or manually posting.",
            "Handle everything on autopilot so you can focus on the art!",
            "Never miss a DM — we automate from first like to final sale.",
        ],
        cta: "Learn More",
    },
    {
        id: "07",
        name: "Growth Hacker",
        tagline: "Let new fans find you while you sleep!",
        bullets: [
            "Clear the path between your audience and your bank account.",
            "Let new fans find you while you sleep!",
            "10X sales per viewer with zero extra effort.",
            "All those people who almost bought? We bring them back.",
        ],
        cta: "Learn More",
    },
    {
        id: "08",
        name: "Audience Spy",
        tagline: "It isn't just data — it's your content strategy's secret weapon!",
        bullets: [
            "Real-time KPI analytics to see your audience clearly.",
            "Predict what performs. Scale without the stress.",
            "It isn't just data — it's your content strategy's secret weapon!",
        ],
        cta: "Learn More",
    },
];

export const RESULTS = [
    {
        name: "Jobby Gonzales",
        stat: "$2,477",
        label: "in total sales",
        image:
            "https://images.unsplash.com/photo-1508179522353-11ba468c4a1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxlZGd5JTIwcG9ydHJhaXQlMjBwaG90b2dyYXBoeSUyMG5lb258ZW58MHx8fHwxNzkyMDM5Njg1fDA&ixlib=rb-4.1.0&q=85",
    },
    {
        name: "Sipan Kazaryan",
        stat: "$400,000",
        label: "in 3.5 months",
        image:
            "https://images.unsplash.com/photo-1644353224392-7e532d7b8f4b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjB5b3VuZyUyMG1hbiUyMHBvcnRyYWl0JTIwbmVvbnxlbnwwfHx8fDE3OTIwMzk2ODV8MA&ixlib=rb-4.1.0&q=85",
    },
    {
        name: "Gilberto Morales",
        stat: "$400,769",
        label: "CAD in sales",
        image:
            "https://images.unsplash.com/photo-1655373325205-bbae7ede0e21?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjB5b3VuZyUyMG1hbiUyMHBvcnRyYWl0JTIwbmVvbnxlbnwwfHx8fDE3OTIwMzk2ODV8MA&ixlib=rb-4.1.0&q=85",
    },
    {
        name: "Creator",
        stat: "$70K",
        label: "of new biz in 1 month",
        image: null,
    },
];

// Exact 12 questions + grouping from the live site.
// Answers are composed only from the site's own phrases (the live FAQ accordion
// content is not publicly extractable).
export const FAQ_GROUPS = [
    {
        group: "Getting Started",
        items: [
            {
                q: "What exactly is Fan Creator and who is it for?",
                a: "Fan Creator is for creators who want to attract more fans, serve them better and keep them longer. You focus on creating — we handle the rest.",
            },
            {
                q: "How quickly will I start seeing results?",
                a: "We convert engagement into passive income, and views to sales in hours - not days!",
            },
            {
                q: "Do I need to already have a following to use Fan Creator?",
                a: "No. The algorithm and automation build your audience - then turn them into loyal buyers.",
            },
        ],
    },
    {
        group: "How It Works",
        items: [
            {
                q: "What platforms does Fan Creator support?",
                a: "Book a free demo and we'll show you exactly how Fan Creator will accelerate your growth on your platforms.",
            },
            {
                q: "Is this real organic growth or does it use bots and fake followers?",
                a: "Real organic growth — no bots, no fake followers. We make the algorithm your friend.",
            },
            {
                q: "Do I have to change my content style to make this work?",
                a: "No. You focus on creating, we handle the rest. Consistency without chaos!",
            },
        ],
    },
    {
        group: "Pricing & Commitment",
        items: [
            {
                q: "How much does Fan Creator cost?",
                a: "Start with a free demo — no credit card required, 100% free — and we'll walk you through everything.",
            },
            {
                q: "Is there a contract or can I cancel anytime?",
                a: "Get in touch and we'll schedule a time for a quick demo — we'll answer every question before you commit to anything.",
            },
            {
                q: "Is there a money-back guarantee?",
                a: "Book a free demo and let's chat — no credit card required, 100% free.",
            },
        ],
    },
    {
        group: "Results & Support",
        items: [
            {
                q: "What makes Fan Creator different from other social media growth tools?",
                a: "We automate everything so creators just create — from first like to final sale.",
            },
            {
                q: "Will I get support or is this a self-service tool?",
                a: "Let's chat! Get in touch and we'll schedule a time for a quick demo. You focus on creating, we handle the rest.",
            },
            {
                q: "Can Fan Creator help me monetize my audience, not just grow it?",
                a: "Yes — turn fan engagement into income with a no brainer sales funnel, and turn viewers into buyers WITHOUT lifting a finger.",
            },
        ],
    },
];

// Exact fragments from the live site's problem section
export const PROBLEM_POINTS = [
    {
        title: "80% of your time",
        text: "You shouldn't have to worry about all the boring tasks that take up 80% of your time.",
    },
    {
        title: "Make the algorithm your friend",
        text: "Stand out with the easiest way to convert engagement into passive income.",
    },
    {
        title: "Hours — not days",
        text: "Views to sales in hours - not days!",
    },
];
